import React from 'react';
import { RcRating, RcRatingProps } from '@ringcentral/juno';
import {
  RatingMixin,
  EmptyRectangle,
  Rectangle,
} from '@/components/ratingAndReview/rectangleRating/RectangleRating.sc';

export const RectangleRating = (props: RcRatingProps) => {
  return (
    // @ts-ignore
    <RcRating
      css={RatingMixin}
      icon={<Rectangle />}
      emptyIcon={<EmptyRectangle />}
      {...props}
    />
  );
};
